export const REASON_CHANGE_CLASS = {
  CHANGE_CENTER: 'CHANGE_CENTER',
  CHANGE_CLASS_SCHEDULE: 'CHANGE_CLASS_SCHEDULE',
  CHANGE_BECAUSE_CLASS_FRIEND: 'CHANGE_BECAUSE_CLASS_FRIEND',
  CHANGE_LEVEL_BECAUSE_MAIN_TEACHER_REQUEST: 'CHANGE_LEVEL_BECAUSE_MAIN_TEACHER_REQUEST',
  CHANGE_LEVEL_BECAUSE_TEACHER_REQUEST: 'CHANGE_LEVEL_BECAUSE_TEACHER_REQUEST',
  CHANGE_LEVEL_BECAUSE_PARENT_REQUEST: 'CHANGE_LEVEL_BECAUSE_PARENT_REQUEST',
  CHANGE_TEACHER_THE_NORTH: 'CHANGE_TEACHER_THE_NORTH',
  CHANGE_TEACHER_THE_SOUTH: 'CHANGE_TEACHER_THE_SOUTH',
  CHANGE_TEACHER_THE_CENTRAL: 'CHANGE_TEACHER_THE_CENTRAL',
  CHANGE_TEACHER_FEMALE_GENDER: 'CHANGE_TEACHER_FEMALE_GENDER',
  CHANGE_TEACHER_MALE_GENDER: 'CHANGE_TEACHER_MALE_GENDER',
  CHANGE_BECAUSE_PARENT_REFLECTING_QUALITY: 'CHANGE_BECAUSE_PARENT_REFLECTING_QUALITY',
  CHANGE_BECAUSE_MAIN_TEACHER_REFLECTING_QUALITY: 'CHANGE_BECAUSE_MAIN_TEACHER_REFLECTING_QUALITY',
  OTHER_REASON: 'OTHER_REASON'
}

export const CLASS_IN_STATUS = {
  NONE: 'NONE',
  HAS_ACCOUNT: 'HAS_ACCOUNT',
  SEARCHING_FOR_ACCOUNT: 'SEARCHING_FOR_ACCOUNT'
}

export const colorClassInStatus = {
  NONE: 'red',
  HAS_ACCOUNT: 'red',
  SEARCHING_FOR_ACCOUNT: ''
}